import { useState, useCallback, useEffect } from "react";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useEditLoaPlugin(iboNumber, plugin, refresh) {
  const { logError } = useLogger({ prefix: "useEditLoaPlugin" });
  const { makeAuthedRequest } = Auth.useContainer();

  const [isWaiting, setIsWaiting] = useState(false);
  const [losAwardId, setLosAwardId] = useState(plugin.losAwardId);
  const [sponsor, setSponsor] = useState(plugin.sponsor);
  const [platinum, setPlatinum] = useState(plugin.platinum);
  const [emerald, setEmerald] = useState(plugin.emerald);
  const [diamond, setDiamond] = useState(plugin.diamond);
  const [wwgSignoff, setWwgSignoff] = useState(plugin.wwgSignoff);
  const [uplineSignoff, setUplineSignoff] = useState(plugin.uplineSignoff);
  const [notes, setNotes] = useState(plugin.notes);
  const [dateAdded, setDateAdded] = useState(plugin.dateAdded);
  const [lastReviewed, setLastReviewed] = useState(plugin.lastReviewed);

  const submit = useCallback(async () => {
    setIsWaiting(true);

    const body = JSON.stringify({
      iboNumber: iboNumber,
      losAwardId: Number(losAwardId),
      sponsor: Number(sponsor),
      platinum: Number(platinum),
      emerald: Number(emerald),
      diamond: Number(diamond),
      wwgSignoff: wwgSignoff,
      uplineSignoff: uplineSignoff,
      notes: notes,
      dateAdded: dateAdded,
      lastReviewed: lastReviewed,
    });

    return makeAuthedRequest(`/v1/membership/loa/external/${iboNumber}`, {
      method: "PUT",
      body: body,
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .catch(logError)
      .finally(() => {
        refresh();
        setIsWaiting(false);
      });
  }, [
    logError,
    makeAuthedRequest,
    refresh,
    losAwardId,
    sponsor,
    platinum,
    emerald,
    diamond,
    wwgSignoff,
    uplineSignoff,
    notes,
    dateAdded,
    lastReviewed,
    iboNumber,
  ]);

  return {
    submit,
    isWaiting,

    losAwardId,
    setLosAwardId,

    sponsor,
    setSponsor,

    platinum,
    setPlatinum,

    emerald,
    setEmerald,

    diamond,
    setDiamond,

    wwgSignoff,
    setWwgSignoff,

    uplineSignoff,
    setUplineSignoff,

    notes,
    setNotes,
  };
}
